export default function correctCaptcha() {
  $('.captcha-submit-button').removeClass("not-validated")
}

function captchaButtonOnClick(e) {
  if ($('.captcha-submit-button').hasClass("not-validated")) {
    e.preventDefault()
    if (window.lang === 'cs') {
      alert('Prosím potvrďte, že jste člověk a ne robot')
    } else {
      alert('Please verify you\'re a human')
    }
  }
}

$(document).ready(function() {
  $('.captcha-submit-button').on("click", captchaButtonOnClick)
})



// WEBPACK FOOTER //
// ./src/browser/oldJs/lib/captcha.js